// /explore Handover dropdown ⇄ the `handover_year` tokens the list and map-pins API read
// (`ready`, `2027`, `2030+`, `2028-Q4`). Quarters narrow every picked year. Pure.

export type HandoverState = { ready: boolean; years: number[]; from: boolean; quarters: number[] };

export const HANDOVER_FROM_YEAR = 2030;

const QUARTER_TOKEN = /^(\d{4})-Q([1-4])$/i;

export const parseHandoverTokens = (tokens: string[]): HandoverState => {
  const years = new Set<number>();
  const quarters = new Set<number>();
  let ready = false;
  let from = false;
  for (const raw of tokens) {
    const token = raw.trim();
    if (token.toLowerCase() === 'ready') ready = true;
    else if (token.endsWith('+')) from = true;
    else if (QUARTER_TOKEN.test(token)) {
      const [, year, q] = token.match(QUARTER_TOKEN)!;
      years.add(Number(year));
      quarters.add(Number(q));
    } else if (/^\d{4}$/.test(token)) years.add(Number(token));
  }
  return {
    ready,
    years: [...years].sort((a, b) => a - b),
    from,
    quarters: [...quarters].sort((a, b) => a - b),
  };
};

export const handoverTokens = ({ ready, years, from, quarters }: HandoverState): string[] => {
  const sortedYears = [...new Set(years)].sort((a, b) => a - b);
  const sortedQuarters = [...new Set(quarters)].sort((a, b) => a - b);
  return [
    ...(ready ? ['ready'] : []),
    ...(sortedQuarters.length
      ? sortedYears.flatMap((y) => sortedQuarters.map((q) => `${y}-Q${q}`))
      : sortedYears.map(String)),
    ...(from ? [`${HANDOVER_FROM_YEAR}+`] : []),
  ];
};
